import { Component, OnInit } from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {TableViewAbstractComponent} from '../../table-view-abstract/table-view-abstract.component';

@Component({
  selector: 'app-table-column-dropdown',
  templateUrl: './table-column-dropdown.component.html',
  styleUrls: ['../../../../views/new-table/new-table.component.css']
})
export class TableColumnDropdownComponent extends TableViewAbstractComponent implements OnInit {
  constructor(
    private taskHttpService: TaskService,
    private nzMessageService: NzMessageService
  ) {
    super(nzMessageService, taskHttpService);
  }

}
